module.exports = __webpack_public_path__ + "static/media/Trash.0020e20a.svg";